import React from "react";
import Skeleton from "react-loading-skeleton";

const LoadingSkeleton = ({ height = 70, borderRadius = 0, marginBottom = 30, marginTop = 0 }) => {
    return <Skeleton style={{marginBottom: marginBottom, borderRadius: borderRadius, marginTop: marginTop}} duration={2} height={height}></Skeleton>;
};

export default LoadingSkeleton;
